import * as React from "react";
import { AuthField } from "../AuthField";
import { AuthButton } from "../AuthButton";
import { PasswordVisibilityToggle } from "../PasswordVisibilityToggle";

type Props = {
  id: string;
  inputRef: React.Ref<HTMLInputElement>;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  error?: string | null;
  /** Highlight the field without a message (wrong password is surfaced by toast). */
  invalid?: boolean;
  showPassword: boolean;
  onToggleShowPassword: () => void;
  onForgotPassword: () => void;
  submitting: boolean;
};

/**
 * Password entry for an existing account. Submits the enclosing form. "Edit" on
 * the settled email above is the way back.
 */
export function PasswordStep({
  id,
  inputRef,
  value,
  onChange,
  onBlur,
  error,
  invalid,
  showPassword,
  onToggleShowPassword,
  onForgotPassword,
  submitting
}: Props) {
  return (
    <div className="flex flex-col gap-5">
      <AuthField
        ref={inputRef}
        id={id}
        label="Password"
        name="password"
        type={showPassword ? "text" : "password"}
        autoComplete="new-password"
        placeholder="Your password"
        value={value}
        invalid={invalid}
        error={error}
        onChange={onChange}
        onBlur={onBlur}
        labelAction={
          <AuthButton variant="link" onClick={onForgotPassword}>
            Forgot Password?
          </AuthButton>
        }
        rightElement={
          <PasswordVisibilityToggle
            shown={showPassword}
            onToggle={onToggleShowPassword}
          />
        }
      />

      <AuthButton
        type="submit"
        fullWidth
        forward
        loading={submitting}
        loadingText="Signing in…"
      >
        Sign In
      </AuthButton>
    </div>
  );
}
